import {
  AbstractControl,
  FormArray,
  FormGroup,
  ValidationErrors,
} from '@angular/forms';
import {
  ALPHA_NUMERIC_PATTERN,
  EMAIL_PATTERN,
  NAME_PATTERN,
  PASSWORD_PATTERN,
} from '../constants/reg-exp-patterns';

export class FormUtils {
  static getTextError(errors: ValidationErrors) {
    for (const key of Object.keys(errors)) {
      switch (key) {
        case 'required':
          return 'Este campo es requerido';

        case 'minlength':
          return `Mínimo de ${errors['minlength'].requiredLength} caracteres`;

        case 'maxlength':
          return `Máximo de ${errors['maxlength'].requiredLength} caracteres`;

        case 'min':
          return `Valor mínimo de ${errors['min'].min}`;

        case 'max':
          return `Valor máximo de ${errors['max'].max}`;

        case 'email':
          return `El valor ingresado no luce como un correo electrónico`;

        case 'pattern':
          const requiredPattern = errors['pattern'].requiredPattern;

          if (requiredPattern === EMAIL_PATTERN) {
            return 'El valor ingresado no luce como un correo electrónico';
          }

          if (requiredPattern === PASSWORD_PATTERN) {
            return 'La contraseña debe tener por lo menos 1 letra minúscula, 1 letra mayúscula, 1 número y contener alguno de los siguientes símbolos: !@#$%^&*';
          }

          if (requiredPattern === NAME_PATTERN) {
            return 'Este campo no debe incluir caracteres especiales';
          }

          if (requiredPattern === ALPHA_NUMERIC_PATTERN) {
            return 'Este campo solo acepta letras y números';
          }

          return 'Error de patrón contra expresión regular';

        default:
          return `Error de validación no controlado ${key}`;
      }
    }

    return null;
  }

  static isValidField(form: FormGroup, fieldName: string): boolean | null {
    return (
      !!form.controls[fieldName].errors && form.controls[fieldName].touched
    );
  }

  static getFieldError(form: FormGroup, fieldName: string): string | null {
    if (!form.controls[fieldName]) return null;

    const errors = form.controls[fieldName].errors ?? {};

    return FormUtils.getTextError(errors);
  }

  static isValidFieldInArray(formArray: FormArray, index: number) {
    return (
      formArray.controls[index].errors && formArray.controls[index].touched
    );
  }

  static getFieldErrorInArray(
    formArray: FormArray,
    index: number
  ): string | null {
    if (formArray.controls.length === 0) return null;

    const errors = formArray.controls[index].errors ?? {};

    return FormUtils.getTextError(errors);
  }

  static isFieldOneEqualFieldTwo(field1: string, field2: string) {
    return (formGroup: AbstractControl) => {
      const field1Value = formGroup.get(field1)?.value;
      const field2Value = formGroup.get(field2)?.value;

      return field1Value === field2Value ? null : { fieldsNotEqual: true };
    };
  }

  static isFieldTwoGreaterThanFieldOne(field1: string, field2: string) {
    return (formGroup: AbstractControl) => {
      const field1Value = +formGroup.get(field1)?.value;
      const field2Value = +formGroup.get(field2)?.value;

      return field2Value > field1Value ? null : { field2MustBeGreater: true };
    };
  }
}
